import React, {useState, Fragment } from 'react';
import {Col,Row, Container} from 'react-bootstrap';
import classes from '../../WebsiteManagement/websiteManagement.module.css';
import VehicleList from './VehicleList';
import VehicleView from './VehicleView';
import AddVehicleType from './addVehicleType';
import AddFeatures from './addFeatures';
import SetPrice from './setPrice';
import VehicleViewPropertyList from './VehicleViewPropertyList';
import AddBusGeneralView from './addVehicleGeneralView';
import AddVehicleGeneralView from './addVehicleGeneralView';

const RentalVehicleVendor = (props)=>{
    const [active,updateActive] = useState('1');
    const items = [
        {id:"1",type:"Add Vehicle"},
        {id:"6",type:"Vehicle Management"},
        {id:"2",type:"Vehicle Vendor List"},
        {id:"3",type:"Add Vehicle Features & Facilities"}
    ]
 
    return(
        <Fragment> 
        <Container fluid style={{paddingLeft:'10px'}}>
            <Row> 
                <Col lg={2} md={12} className={classes.Response2}>
                    <div style={{height:'100%'}}> 
                        <ul className={classes.Ul}>
                            {
                                items.map(item=><li 
                                    key={item.id} 
                                    onClick={()=>updateActive(item.id)}
                                    className={classes.Li}
                                    style={{backgroundColor:`${active===item.id?'steelblue':'#585858'}`,textAlign:'center'}}>
                                    {item.type}
                                    </li>
                                )
                            }
                            {
                                active==="4"?<li 
                                onClick={()=>updateActive("2")}
                                className={classes.Li}
                                style={{backgroundColor:`${active==="4"?'steelblue':'#585858'}`,textAlign:'center'}}>
                                Back
                                </li>:null
                            }
                        </ul>
                    </div>
                </Col>
                <Col lg={10} md={12} className={classes.Response}>
                    <div style={{height:'100%'}}> 
                        {
                            active==="1"?<AddVehicleType click={()=>updateActive("2")}/>:
                            active==="2"?<VehicleList click={()=>updateActive("5")}/>:
                            active==="3"?<AddFeatures/>:
                            active==="4"?<VehicleView/>:
                            active==="5"?<AddVehicleGeneralView click={()=>updateActive("1")}/>:
                            active==="6"?<SetPrice click={()=>updateActive("1")}/>:null
                        }   
                    </div>
                </Col>
            </Row>
        </Container>
        </Fragment>
    )
}

export default RentalVehicleVendor;